/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallenge } from '../challenge-schema';
import { challengeSchema } from '../challenge-schema';

const getChallengeDataSchema = challengeSchema.extend({
  clipCount: z.number(),
  collectionCount: z.number(),
});

export type IGetChallengeData = IChallenge & { clipCount: number; collectionCount: number };

export const getChallengeResponseSchema = createApiResponseSchema(
  getChallengeDataSchema,
) as import('zod').ZodSchema<IAPI<IGetChallengeData>>;

export type IGetChallengeResponse = IAPI<IGetChallengeData>;
